import React from "react";
import {
  IConveyorBoxItemUI,
  IConveyorBoxItemWithOptionalItemsUI,
} from "../../../lib/interfaces/ConveyorBox/IConveyorBox";
import BoxItem from "../BoxItem/BoxItem";
import styles from "./BoxItemList.module.css";
import classNames from "classnames";
import { PickProgressActions } from "../OrderOverview/OrderOverview";
import useVerifyItemsA2 from "../../../hooks/useVerifyItems/useVerifyItemsA2";
import { getStructuredBoxItems, isBoxItemVerified } from "../../../utils/helpers/conveyor-box";

type Props = {
  items: IConveyorBoxItemUI[];
  actions: Omit<PickProgressActions, "onAutoVerifyQuantity">;
  isLoadingStock: boolean;
};
const BoxItemList = ({ items, actions, isLoadingStock }: Props) => {
  const { onIncreaseAdjustedPick, onDecreaseAdjustedPick, onConfirmExcessPicks } = actions;

  const classes = classNames(["control-app__content", styles["box-item-list"]]);
  const orderSkuIds = Array.from(new Set(items.map((item) => item.orderSkuID)));

  const {
    onAutoVerifyQuantity,
    onVerifyItemById,
    isAllItemsVerified,
    onUnverifyItemById,
  } = useVerifyItemsA2({
    items: items,
  });

  const onTryDecreaseRxBagPick = () => {
    alert("Det går inte att minska plock för en sluten rx-påse.");
  };

  const { otc, bundles } = getStructuredBoxItems(items);

  return (
    <ul className={classes}>
      {[...bundles, ...otc].map((item, i) => {
        const castedItem = item as IConveyorBoxItemWithOptionalItemsUI;
        const {
          confirmedQuantity,
          pickedQuantity,
          adjustedPickedQuantity,
          verifiedQuantity,
        } = item;
        const isVerified = isBoxItemVerified(item);
        const isPickFinished =
          confirmedQuantity === pickedQuantity && adjustedPickedQuantity === pickedQuantity;
        const isVerificationFinished =
          confirmedQuantity === pickedQuantity && verifiedQuantity >= pickedQuantity;
        const isPickingFinished = isAllItemsVerified ? isPickFinished : isVerificationFinished;
        const isFinished =
          pickedQuantity < 1 && item.picks.remaining > 0 ? true : isPickingFinished;

        const bundleItems = castedItem?.items;

        if (bundleItems?.length > 0 && item.deliveredQuantity < item.confirmedQuantity) {
          return bundleItems.map((item, i) => (
            <BoxItem
              orderSkuIds={orderSkuIds}
              key={i}
              item={item}
              onIncreaseAdjustedPick={isVerified ? onIncreaseAdjustedPick : onVerifyItemById}
              onDecreaseAdjustedPick={
                item.attributes.includes("RXBAG")
                  ? onTryDecreaseRxBagPick
                  : isVerified
                  ? onDecreaseAdjustedPick
                  : onUnverifyItemById
              }
              onConfirmExcessPicks={onConfirmExcessPicks}
              onAutoVerifyQuantity={onAutoVerifyQuantity}
              isLoadingStock={isLoadingStock}
              isFinished={isFinished}
              index={i}
            />
          ));
        }
        return (
          <BoxItem
            orderSkuIds={orderSkuIds}
            key={i}
            item={item}
            onIncreaseAdjustedPick={isVerified ? onIncreaseAdjustedPick : onVerifyItemById}
            onDecreaseAdjustedPick={
              item.attributes.includes("RXBAG")
                ? onTryDecreaseRxBagPick
                : isVerified
                ? onDecreaseAdjustedPick
                : onUnverifyItemById
            }
            onConfirmExcessPicks={onConfirmExcessPicks}
            onAutoVerifyQuantity={onAutoVerifyQuantity}
            isLoadingStock={isLoadingStock}
            isFinished={isFinished}
            bagQuantity={bundleItems?.reduce((acc, curr) => acc + curr.confirmedQuantity, 0)}
          />
        );
      })}
    </ul>
  );
};

export default BoxItemList;
